import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import folderId from 'owa-service/lib/factory/folderId';
/**
 * @param tableView for which we want to get the server base folder id
 * @return Returns the BaseFolderId for the table view
 */
export function getBaseServerFolderId(tableView) {
    // For MarkAllAsRead on left nav, the group might not have been loaded yet so we don't have a real serverFolderId set.
    // In that case we need to use the DistinguishedFolderId instead.
    if (tableView.serverFolderId == tableView.tableQuery.folderId) {
        return getBaseFolderId(tableView.tableQuery);
    }
    return getFolderId(tableView.serverFolderId);
}
/**
 * @param tableQuery for which we want to get the base folder id
 * @return Returns BaseFolderId for the tableQuery
 */
export default function getBaseFolderId(tableQuery) {
    return tableQuery.type == 2 /* Group */
        ? getBaseFolderIdForGroup(tableQuery.folderId)
        : getFolderId(tableQuery.folderId);
}
function getBaseFolderIdForGroup(groupId) {
    return distinguishedFolderId({
        Id: 'inbox',
        Mailbox: {
            MailboxType: 'GroupMailbox',
            EmailAddress: groupId,
        },
    });
}
function getFolderId(folderIdString) {
    return folderId({ Id: folderIdString });
}
//# sourceMappingURL=getBaseFolderId.js.map